<script lang="ts" setup>
    import MediceLogo from '~/assets/images/logo.white.svg';
    import GradientCircle from '~/assets/images/gradient-circle-white.svg';
    import PTAHeroBackgroundAnimated from './PTAHeroBackgroundAnimated.vue';
    import HeroMedia from '~/components/heroElements/HeroMedia.vue';

    const props = defineProps<{ blok: HeroComponentStoryblok }>();
    const { headlineContent, mediaSrc, mediaAlt, mediaContentType } = useHeroComponentContent(() => props.blok);
</script>

<template>
    <div
        v-editable="props.blok"
        class="hero-container"
    >
        <div class="hero-wrapper">
            <div class="logo-wrapper">
                <img
                    :src="MediceLogo"
                    aria-hidden="true"
                    class="medice-logo"
                />
            </div>

            <div class="content">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="headline"
                    v-html="headlineContent"
                />
                <!-- eslint-enable vue/no-v-html -->

                <div
                    v-if="props.blok.button"
                    class="btn-wrapper"
                >
                    <StoryblokComponentWrapper
                        v-for="item in props.blok.button"
                        :key="item._uid"
                        :blok="item"
                    />
                </div>
            </div>

            <div class="media-content">
                <HeroMedia
                    :src="mediaSrc"
                    :alt="mediaAlt"
                    :content-type="mediaContentType"
                    storage-key="pta-hero-paused"
                />

                <img
                    :src="GradientCircle"
                    class="gradient-circle"
                    alt=""
                />
            </div>
        </div>

        <HeroScrollDown />
        <PTAHeroBackgroundAnimated />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/pta-hero-section.scss';
</style>
